import {
  getSubscription,
  isFeatureExpired,
  isFeatureSubscribed,
} from "../../../../Utils/Auth/ValidatePermissions";

const EXPIRING_SOON_DAYS = 30;

const isExpiringSoon = (value) => {
  if (!value) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const targetDate = new Date(value);
  targetDate.setHours(0, 0, 0, 0);

  const diffTime = targetDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays >= 0 && diffDays <= EXPIRING_SOON_DAYS;
};

export const getProductMetrics = (product) => {
  const features = product?.features ?? [];

  return features.reduce(
    (summary, feature) => {
      const featurePermission = getSubscription(feature?.Permissions);
      const subscriptionEndDate = featurePermission?.SubscriptionEndDate;
      const subscribed = isFeatureSubscribed(feature);
      const expired = isFeatureExpired(subscriptionEndDate);

      return {
        moduleCount: summary.moduleCount + 1,
        activeCount: summary.activeCount + (subscribed && !expired ? 1 : 0),
        subscribedCount: summary.subscribedCount + (subscribed ? 1 : 0),
        expiringSoonCount:
          summary.expiringSoonCount +
          (subscribed && !expired && isExpiringSoon(subscriptionEndDate)
            ? 1
            : 0),
        disabledCount: summary.disabledCount + (!feature?.IsEnabled ? 1 : 0),
      };
    },
    {
      moduleCount: 0,
      activeCount: 0,
      subscribedCount: 0,
      expiringSoonCount: 0,
      disabledCount: 0,
    },
  );
};

export const getPortfolioMetrics = (products = []) =>
  products.reduce(
    (summary, product) => {
      const metrics = getProductMetrics(product);

      return {
        productsCount: summary.productsCount + 1,
        moduleCount: summary.moduleCount + metrics.moduleCount,
        activeCount: summary.activeCount + metrics.activeCount,
        expiringSoonCount:
          summary.expiringSoonCount + metrics.expiringSoonCount,
      };
    },
    {
      productsCount: 0,
      moduleCount: 0,
      activeCount: 0,
      expiringSoonCount: 0,
    },
  );
